/* eslint-disable import/no-extraneous-dependencies */

import { GridColDef } from '@mui/x-data-grid';
import { BrowseView, browseViewColumnAction } from '@pro4-erp/core-web';
import { Edit as EditIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ClientVisit } from '../types';
import { getFinishedClientVisitsForMe } from '../api/getFinishedClientVisitsForMe';
import { getBeautifiedLocalDate } from '@/core';

const FinishedBrowseView = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const navigate = useNavigate();

  const columns: GridColDef<ClientVisit>[] = [
    {
      ...browseViewColumnAction({
        field: 'actions',
        headerName: t('Open', { defaultValue: 'Open' }),
        icon: {
          element: <EditIcon />,
          color: 'primary',
        },
        onClick: ({ params }) => navigate(`/client-visits/${params.id}`),
      }),
      display: 'flex',
    },
    {
      field: 'uId',
      display: 'flex',
      headerName: t('uId', { defaultValue: 'uId' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
    },
    {
      field: 'proposedTime',
      display: 'flex',
      headerName: t('Proposed time', { defaultValue: 'Proposed time' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
    },
    {
      field: 'services',
      display: 'flex',
      headerName: t('Services', { defaultValue: 'Services' }).toString(),
      flex: 1.5,
      minWidth: 200,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (params.row.services) {
          const title = params.row.services
            .map((service) => `${service.serviceShowAs}`)
            .join(',\n');
          return (
            <ul
              style={{ paddingLeft: 15 }}
              className="MuiDataGrid-cellContent"
              title={title || ' '}
            >
              {params.row.services.map((service) => (
                <li key={service.id}>{service.serviceShowAs}</li>
              ))}
            </ul>
          );
        }
        return <> </>;
      },
    },
    {
      field: 'reports',
      display: 'flex',
      headerName: t('Reports', { defaultValue: 'Reports' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
      valueGetter(_, row) {
        return row.reports || 'N/A';
      },
    },
    {
      field: 'standards',
      display: 'flex',
      headerName: t('Standards', { defaultValue: 'Standards' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
      valueGetter(_, row) {
        return row.standards || 'N/A';
      },
    },
    {
      field: 'status',
      display: 'flex',
      headerName: t('Status', { defaultValue: 'Status' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
    },
    {
      field: 'teamMembers',
      display: 'flex',
      headerName: t('Team members', { defaultValue: 'Team members' }).toString(),
      flex: 1.5,
      minWidth: 200,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (params.row.teamMembers) {
          const title = params.row.teamMembers
            .map((member) => `${member.name} ${member.role}`)
            .join(',\n');
          return (
            <ul style={{ paddingLeft: 15 }} className="MuiDataGrid-cellContent" title={title || ''}>
              {params.row.teamMembers.map((member) => (
                <li key={member.id}>
                  {member.name} {member.role}
                </li>
              ))}
            </ul>
          );
        }
        return <> </>;
      },
    },
    {
      field: 'datStart',
      display: 'flex',
      headerName: t('Start date', { defaultValue: 'Start date' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      valueGetter(_, row) {
        return row.datStart ? getBeautifiedLocalDate(row.datStart) : 'N/A';
      },
    },
    {
      field: 'datEnd',
      display: 'flex',
      headerName: t('End date', { defaultValue: 'End date' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      valueGetter(_, row) {
        return row.datEnd ? getBeautifiedLocalDate(row.datEnd) : 'N/A';
      },
    },
    {
      field: 'businessType',
      display: 'flex',
      headerName: t('Business type', { defaultValue: 'Business type' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
    },
  ];

  return (
    <BrowseView
      browserViewContainerSx={{
        height: '100vh',
      }}
      columns={columns}
      fetchData={(params) => getFinishedClientVisitsForMe({ ...params, lang })}
      toolbar={<BrowseView.Toolbar showSearch />}
      getRowHeight={() => 'auto'}
    />
  );
};

export default FinishedBrowseView;
